// extracted by mini-css-extract-plugin
module.exports = {"container":"NoInternetStatus_container__3C7VB","close":"NoInternetStatus_close__3jsk0"};